import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CoffeService } from '../../interfaces/CoffeService.interface';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';

@Component({
  selector: 'coffe-shop-card',
  templateUrl: 'coffe-shop-card.html'
})
export class CoffeShopCardComponent {
  @Input('service') service: CoffeService;
  @Input('showQuantity') showQuantity: boolean;
  @Output() open = new EventEmitter();
  @Output() edit = new EventEmitter();
  constructor(public navCtrl: NavController, public coffeShopService: CoffeShopService) {}
  public openService(): void {
    this.open.emit(this.service);
  }
  public editService(): void {
    this.edit.emit(this.service);
  }
}



// WEBPACK FOOTER //
// ./src/components/coffe-shop-card/coffe-shop-card.ts